import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Initialize i18n before rendering
import './i18n';

// IMPORTANT: Leaflet CSS MUST be imported BEFORE Tailwind to prevent conflicts
import 'leaflet/dist/leaflet.css';

// Tailwind CSS
import './styles/tailwind.css';

// Global styles (custom) - includes Leaflet fixes
import './styles/global.css';

// Legacy styles (to be removed progressively)
import './styles/auth.css';
import './styles/error.css';
import './styles/gamification-basic.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
